import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface IBoard {
  [key: string]: any;
  loading: boolean;
  data: any;
}

export interface IState {
  [key: string]: any;
  menu: IBoard;
}

export const state: IState = {
  menu: {
    loading: false,
    data: []
  },
  accessUser: {
    loading: false,
    total: 0,
    data: []
  },
  setAccessUser: {
    loading: false,
    success: false
  },
  adminUser: {
    loading: false,
    infos: []
  },
  setAdminUser: {
    loading: false,
    success: false
  },
  hasBoardHead: {
    loading: false,
    access: false
  },
  productDocs: {
    loading: false,
    infos: []
  },
  productDocById: {
    infos: []
  },
  productEvns: {
    loading: false,
    infos: []
  },
  businessDocTypes: {},
  businessUrl: "",
  gitBranchInfo: {},
  saveForm: {
    loading: false,
    access: false
  }
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  menu: (myState: IState) => myState.menu,
  accessUser: (myState: IState) => myState.accessUser,
  adminUser: (myState: IState) => myState.adminUser,
  setAccessUser: (myState: IState) => myState.setAccessUser,
  productDocs: (myState: IState) => myState.productDocs,
  productDocById: (myState: IState) => myState.productDocById,
  productEvns: (myState: IState) => myState.productEvns,
  businessDocTypes: (myState: IState) => myState.businessDocTypes,
  businessUrl: (myState: IState) => myState.businessUrl,
  gitBranchInfo: (myState: IState) => myState.gitBranchInfo,
  saveForm: (myState: IState) => myState.saveForm,
  setAdminUser: (myState: IState) => myState.setAdminUser,
  hasBoardHead: (myState: IState) => myState.hasBoardHead
};
